import { Component, Input } from '@angular/core';

@Component({
  selector: 'unicon-accordion-cotization-card',
  templateUrl: './accordion-cotization-card.component.html',
})
export class AccordionCotizationCardComponent {
  @Input() btn: boolean = true;
}
